import { Typography } from "@mui/material";
import React from "react";

const Undertaking = (props) => {
    return (
        <div>
            <Typography sx={termstextBold} gutterBottom>
                Undertaking
            </Typography>
            <Typography sx={termstext} paragraph>
                They hereby represent, warrant, agree and undertake as follows-
            </Typography>

            <Typography sx={termstext} paragraph>
                1. That, the member or any person who acts on behalf of or at the direction of the member,
                shall not use (or enable others to use) the Services or anything created using the Services in
                connection with:
            </Typography>
            <Typography sx={termstext} paragraph>
                (i) activities relating to nuclear, chemical, or biological weapons proliferation, terrorism,
                ammunition, corruption, hazardous waste, undermining of democratic rights and government,
                money laundering, financial crime, tax evasion, misrepresentation, misuse of customer/end-users
                rights/data, fraud or human rights violations, or other similarly egregious activities or
            </Typography>

            <Typography sx={termstext} paragraph>
                2. The Member immediately notify BXI in writing, no later than 24 (twenty-four) hours for the
                following
            </Typography>
            <Typography sx={termstext} paragraph>
                (i) occurrence of any breach or knowledge of the breach of this Undertaking.
            </Typography>

            <Typography sx={termstext} paragraph>
                (ii) In case of violation of the provisions under this Undertaking/ Agreement, receipt of notice
                /knowledge of any claim, suit, action, complaint, or proceeding related to this Undertaking,
            </Typography>

            <Typography sx={termstext} paragraph>
                (iii) any breach, non-fulfilment, or failure to comply with this Undertaking.
            </Typography>

            <Typography sx={termstext} paragraph>
                (iv) any misrepresentation or inaccuracy of the representations and warranties of the Member
                hereunder or any of the representations and warranties as provided hereunder by the Member
                being untrue, misleading, or incorrect.
            </Typography>

            <Typography sx={termstext} paragraph>
                3. Each time the Member shall follow all rules and regulations of BXI. The Member shall not
                violate any Indian Law at any point of time including but not limited to trading, listing goods
                and/or services etc. The Member shall not engage in any conduct that would cause BXI to violate
                trade, financial and economic sanctions maintained by the Indian government and/or under
                Applicable Laws.
            </Typography>
            {/* <Typography sx={termstext} paragraph>
                Member agrees to pay BXI a success fee, calculated at a rate of 12% for
                Standard members and 8% for Advanced members, based on the total amount of each
                trade purchased from other BXI Members on the Marketplace platform.
            </Typography> */}

            {/* <Typography sx={termstextBold} gutterBottom>
                4. Trade Credits and Credit Line Policies
            </Typography> */}
            <Typography sx={termstext} paragraph>
                4. BXI shall have a right to audit the Member during the Term of this Agreement and three (3)
                years thereafter, through itself or independent auditors, the records/ data/ information of the
                Member in relation to this Undertaking/ Agreement. In case of any breach or event that might lead
                to the breach of this Undertaking, Member shall immediately undertake all the measures notified
                by BXI to cure the breach/ potential under this Undertaking or any other actions BXI suggestions in
                relation to this Undertaking. The Member shall be liable for any liabilities or actions arising out of a
                breach of this Undertaking by the Member and the Member hereby agrees and undertakes that
                BXI shall not be liable for any breach arising out of this Undertaking by the Member.
            </Typography>

            {/* <Typography sx={termstextBold} gutterBottom>
                5. Voluntary Trades and Transactions
            </Typography> */}
            <Typography sx={termstext} paragraph>
                5. The Member will indemnify and keep indemnified and hold harmless, BXI from and against
                all losses, damages, claims, demands, costs, and expenses (including legal fees and attorney
                charges) which the BXI may suffer or incur, as well as all actions, suits, and proceedings which the
                Indemnified Party may face and all costs, charges and expenses relating thereto, arising out of:
            </Typography>

            {/* <Typography sx={termstextBold} gutterBottom>
                6. Responsibility for Trades and Disputes
            </Typography> */}
            <Typography sx={termstext} paragraph>
                (i) any misrepresentation or inaccuracy of the representations and warranties of the Member
                hereunder or any of the representations and warranties as provided hereunder by the Member
                being untrue, misleading, or incorrect.
            </Typography>

            <Typography sx={termstext} paragraph>
                (ii) any breach, non-fulfilment, or failure to comply (whether in whole or part) with any
                obligation or covenant covered under this Undertaking.
            </Typography>


            <Typography sx={termstext} paragraph>
                (iii) any negligence (including delay or deficiency to perform its obligations under this
                Undertaking), fraudulent act or concealment on the part of the Member.
            </Typography>

            <Typography sx={termstext} paragraph>
                (iv) any claim, suit, action or proceeding related to this
            </Typography>
        </div>
    );
};

export default Undertaking;

const termstext = {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: {
        xl: "14px",
        lg: "14px",
        md: "13px",
        sm: "8px",
        xs: "8px",
    },
    lineHeight: "20px",
    textAlign: "justify",
    color: "#7D8BA6",
};

const termstextBold = {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: {
        xl: "15px",
        lg: "15px",
        md: "13px",
        sm: "8px",
        xs: "8px",
    },
    lineHeight: "20px",
    textAlign: "justify",
    color: "#000",
};
